<div *ngIf="type" class="my-3 p-3 rounded-lg" [class]="alertClass">
    <ng-content></ng-content>
</div>
